// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2--Ia","sendOtp":"AuthorizeToLogin_sendOtp__2RIxs"};